module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getInformationMsg.isShown == true) ? _c('div', {
    ref: "informationMsg",
    staticClass: "inform-popup",
    class: _vm.getInformationMsg.className,
    attrs: {
      "role": "alert",
      "id": "information-message"
    }
  }, [_c('div', {
    staticClass: "inform-message-inner"
  }, [_c('h2', {
    staticClass: "inform-title"
  }, [_vm._v(_vm._s(_vm.getInformationMsg.title))]), _vm._v(" "), _c('p', {
    staticClass: "inform-content"
  }, [_vm._v(_vm._s(_vm.getInformationMsg.text))]), _vm._v(" "), _c('button', {
    staticClass: "inform-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeInformationMsg($event)
      }
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bd3a451","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/InfomMsg.vue
// module id = 1032
// module chunks = 0